import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { TerminArtLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface TerminArtProps {
    disabled?: boolean;
    value: string;
    addAll?: boolean;
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle' };

export const TerminArt: React.FC<TerminArtProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    addAll = false,
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        if (addAll) {
            list.push(allOption);
        }

        Object.keys(TerminArtLabel).forEach((key) => {
            list.push({
                value: key,
                label: TerminArtLabel[key],
            });
        });

        return list;
    }, [addAll]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: TerminArtLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Art</Label>}
            <Select
                name="terminArt"
                isDisabled={disabled}
                value={selectedOption}
                options={options}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Art' : ''}
            />
        </>
    );
};
